import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {deleteDiscountApi, getAllDiscountsApi, postDiscountApi, updateDiscountApi} from "../../api/backendAPIs";


export const fetchAllDiscountsType = createAsyncThunk('fetchTicketType', async () => {
  return await getAllDiscountsApi()
})

export const deleteDiscountById = createAsyncThunk('deleteTicketType', async (payload) => {
  return deleteDiscountApi(payload);
})

export const postDiscount = createAsyncThunk('postTicketType', async (payload) => {
  return postDiscountApi(payload);
})

export const updateDiscount = createAsyncThunk('updateDiscount', async (payload) => {
  return updateDiscountApi(payload)
})

const initialState = {
  discountList: [],
  allDiscountList: [],
  loadingDiscounts: false,
  searchParam: ""
}

export const discountSlice = createSlice({
  name: 'discounts',
  initialState,
  reducers: {
    setSearchParam: (state, action) => {
      state.searchParam = action.payload
    }
  },
  extraReducers: {
    [fetchAllDiscountsType.pending]: (state) => {
      state.loadingDiscounts = true;
    },
    [fetchAllDiscountsType.fulfilled]: (state, {payload}) => {
      state.discountList = payload.data.content.filter(i => i.active);
      state.allDiscountList = payload.data.content;
      state.loadingDiscounts = false;
    },
    [fetchAllDiscountsType.rejected]: (state) => {
      state.loadingDiscounts = false;
    },
    [postDiscount.pending]: (state) => {
      state.loadingDiscounts = true;
    },
    [postDiscount.fulfilled]: (state, {payload}) => {
      let arr = [...current(state.discountList)]
      arr.push(payload.data)
      state.discountList = arr
      state.loadingDiscounts = false;
    },
    [postDiscount.rejected]: (state) => {
      state.loadingDiscounts = false;
    },
    [updateDiscount.pending]: (state) => {
      state.loadingDiscounts = true;
    },
    [updateDiscount.fulfilled]: (state, {payload}) => {
      const arr = [...current(state.discountList)]
      const foundIndex = arr.findIndex(i => i.id ===  payload.data.id)
      if(foundIndex !== -1){
        arr[foundIndex] = payload.data
        state.discountList = arr
      }
      state.loadingDiscounts = false
    },
    [updateDiscount.rejected]: (state) => {
      state.loadingDiscounts = false;
    },
    [deleteDiscountById.pending]: (state) => {
      state.loadingDiscounts = true;
    },
    [deleteDiscountById.fulfilled]: (state, action) => {
      const arr = [...current(state.discountList)]
      const foundIndex = arr.findIndex(i => i.id === action.meta.arg)
      if (foundIndex !== -1) {
        arr.splice(foundIndex, 1)
        state.discountList = arr
      }
      state.loadingDiscounts = false;
    },
    [deleteDiscountById.rejected]: (state) => {
      state.loadingDiscounts = false;
    }
  }
});

export const discountReducer = discountSlice.reducer
